import { getPartner } from 'packages/smart-home-support/partner';
import SafeConsole from '../../../util/ConsoleUtils';
import Mark from '../../../resources/ExperienceCards/ExpertImage_Mark.jpg';
import Rachel from '../../../resources/ExperienceCards/ExpertImage_Rachel.jpg';

const SHS_WEB_quotesData = {
  name: 'Justin K.',
  jobTitle: 'Smart Home Support expert by day, amateur pastry chef by night',
  quote:
    "I love helping people solve their tech problems. It's so rewarding to be able to remove so much frustration from people's lives all day long!",
  photo: Mark,
};

const TCH_WEB_quotesData = {
  ...SHS_WEB_quotesData,
  jobTitle: `${getPartner().productName} expert by day, amateur pastry chef by night`,
};

const SHS_SPRINT_quotesData = {
  name: 'Rachel W.',
  jobTitle: 'Sprint Complete MyHome expert by day, children’s book illustrator by night',
  quote:
    'My favorite calls are the ones where I can help people watch their favorite movies and shows on all of their devices. I love the feeling I get when I help someone learn something new!',
  photo: Rachel,
};

const SHS_ASURION_quotesData = {
  name: 'Rachel W.',
  jobTitle: 'Asurion expert by day, children’s book illustrator by night',
  quote:
    'My favorite calls are the ones where I can help people watch their favorite movies and shows on all of their devices. I love the feeling I get when I help someone learn something new!',
  photo: Rachel,
};

let QuotesData = null;

switch (globals.REACT_APP_PARTNER) {
  case 'SHS-WEB':
    QuotesData = SHS_WEB_quotesData;
    break;
  case 'SHS-SPRINT':
    QuotesData = SHS_SPRINT_quotesData;
    break;
  case 'SHS-ASURION':
    QuotesData = SHS_ASURION_quotesData;
    break;
  case 'TCH-WEB':
    QuotesData = TCH_WEB_quotesData;
    break;
  default:
    SafeConsole.error('globals.REACT_APP_PARTNER is invalid, globals.REACT_APP_PARTNER = ', globals.REACT_APP_PARTNER);
    break;
}

export default QuotesData;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/shs/Quotes/Quotes.data.js